/** 心理测试应用配置 - 独立应用入口 */
import type { LucideIcon } from 'lucide-react';
import {
  Brain,
  Activity,
  Zap,
  Heart,
  Sparkles,
  Star,
  Users,
  Shield,
  Moon,
  Lightbulb,
  Target,
  MapPin,
  Fingerprint,
} from 'lucide-react';

export interface PsychAppConfig {
  id: string;
  label: string;
  icon: LucideIcon;
  gradient: string;
  borderColor: string;
  testId: string;
}

export const PSYCH_APPS: PsychAppConfig[] = [
  { id: 'psychSbti', label: 'SBTI', icon: Star, gradient: 'from-blue-400 to-indigo-600', borderColor: 'border-blue-300/50', testId: 'sbti' },
  { id: 'psychMbti', label: 'MBTI', icon: Brain, gradient: 'from-amber-400 to-amber-600', borderColor: 'border-amber-300/50', testId: 'mbti' },
  { id: 'psychMbtiStage', label: 'MBTI阶段', icon: Brain, gradient: 'from-emerald-400 to-emerald-600', borderColor: 'border-emerald-300/50', testId: 'mbti_stage' },
  { id: 'psychBeauty', label: '颜值测试', icon: Sparkles, gradient: 'from-rose-400 to-pink-500', borderColor: 'border-rose-300/50', testId: 'beauty' },
  { id: 'psychScl90', label: '抑郁症', icon: Activity, gradient: 'from-teal-400 to-teal-600', borderColor: 'border-teal-300/50', testId: 'scl90' },
  { id: 'psychBipolar', label: '双相筛查', icon: Zap, gradient: 'from-sky-400 to-sky-600', borderColor: 'border-sky-300/50', testId: 'bipolar' },
  { id: 'psychSexRepress', label: '性压抑', icon: Heart, gradient: 'from-rose-400 to-rose-600', borderColor: 'border-rose-300/50', testId: 'sex_repress' },
  { id: 'psychQuirk', label: '心理怪癖', icon: Sparkles, gradient: 'from-amber-400 to-amber-600', borderColor: 'border-amber-300/50', testId: 'quirk' },
  { id: 'psychPreference', label: '性偏好', icon: Heart, gradient: 'from-fuchsia-400 to-rose-500', borderColor: 'border-fuchsia-300/50', testId: 'preference' },
  { id: 'psychRole', label: '性角色', icon: Users, gradient: 'from-rose-400 to-rose-600', borderColor: 'border-rose-300/50', testId: 'role' },
  { id: 'psychAbo', label: '潜在性别', icon: Shield, gradient: 'from-indigo-400 to-indigo-600', borderColor: 'border-indigo-300/50', testId: 'abo' },
  { id: 'psychDark', label: '黑暗人格', icon: Moon, gradient: 'from-slate-500 to-slate-700', borderColor: 'border-slate-400/40', testId: 'dark' },
  { id: 'psychTalent', label: '天赋图', icon: Lightbulb, gradient: 'from-blue-400 to-indigo-600', borderColor: 'border-blue-300/50', testId: 'talent' },
  { id: 'psychNeeds', label: '精神需求测试', icon: Target, gradient: 'from-emerald-400 to-emerald-600', borderColor: 'border-emerald-300/50', testId: 'needs' },
  { id: 'psychCity', label: '理想城市', icon: MapPin, gradient: 'from-sky-400 to-sky-600', borderColor: 'border-sky-300/50', testId: 'city' },
  { id: 'psychEnneagram', label: '九型人格', icon: Fingerprint, gradient: 'from-teal-400 to-teal-600', borderColor: 'border-teal-300/50', testId: 'enneagram' },
];
